module.exports = __webpack_public_path__ + "img/10.42614012.jpg";